import { cn } from '@/utils/cn';
import type { ReactNode } from 'react';

type CalloutVariant = 'info' | 'success' | 'warning' | 'error';

const variants: Record<CalloutVariant, string> = {
  info: 'border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-900/50 dark:text-slate-300',
  success: 'border-success-100 bg-success-50 text-success-700 dark:border-emerald-900 dark:bg-emerald-950/30 dark:text-emerald-300',
  warning: 'border-warning-100 bg-warning-50 text-warning-800 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-300',
  error: 'border-error-100 bg-error-50 text-error-700 dark:border-red-900 dark:bg-red-950/30 dark:text-red-300',
};

interface CalloutProps {
  children: ReactNode;
  variant?: CalloutVariant;
  title?: string;
  className?: string;
}

export function Callout({ children, variant = 'info', title, className }: CalloutProps) {
  return (
    <div className={cn('rounded-lg border px-4 py-3 text-sm', variants[variant], className)} role="note">
      {title && <p className="mb-1 font-medium">{title}</p>}
      <div className="text-[13px] leading-relaxed">{children}</div>
    </div>
  );
}
